<script setup>
import RealEstateBrokerInvestmentPortfolioChart from './RealEstateBrokerInvestmentPortfolioChart.vue';
import RealEstateBrokerInvestmentTemperatureCard from './RealEstateBrokerInvestmentTemperatureCard.vue';

const props = defineProps({
  activeTemperature: { type: String, default: '' },
  loading: { type: Boolean, default: false },
  summary: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['select']);
const isSelected = temperature => props.activeTemperature === temperature;
</script>

<template>
  <section class="space-y-3" :aria-busy="loading">
    <RealEstateBrokerInvestmentPortfolioChart
      :loading="loading"
      :summary="summary"
    />
    <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
      <RealEstateBrokerInvestmentTemperatureCard
        v-for="item in summary.temperaturas || []"
        :key="item.slug"
        :item="item"
        :loading="loading"
        :selected="isSelected(item.slug)"
        @select="emit('select', $event)"
      />
    </div>
  </section>
</template>
